import {
  CREATE_SYSTEM_SURVEY,
  LOAD_USER_SURVEYS,
  SAVE_SYSTEM_SURVEY
} from '../../actions/surveys'
import * as h2Api from '../../h2Api'

const initialState = {
  listing: null
}
const sort = inp => {
  console.log(inp)

  if (!Array.isArray(inp)) {
    return inp
  }

  return inp.sort((a, b) => {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1
    }

    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1
    }

    return 0
  })
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SYSTEM_SURVEY:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          listing: sort([...state.listing, action.restCall.result])
        }
      }

      return state

    case SAVE_SYSTEM_SURVEY:
      return state

    case LOAD_USER_SURVEYS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          listing: sort(action.restCall.result)
        }
      }

      return state

    default:
      return state
  }
}

export default reducers
